<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="germplasm-list.variable.matches.header"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div class="modal-body">
	<h4 jhiTranslate="germplasm-list.variable.matches.entry.details"></h4>
	<br/>
	<div>
		<div class="row">
			<div class="col">
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-curved">
						<thead>
                        <tr>
						<th jhiTranslate="germplasm-list.variable.matches.columns.name"></th>
						<th jhiTranslate="germplasm-list.variable.matches.columns.description"></th>
						<th jhiTranslate="germplasm-list.variable.matches.columns.status"></th>
                        </tr>
						</thead>
						<tbody *ngIf="rows && rows.length else nodata">
						<tr *ngFor="let variable of rows | slice: (page-1) * pageSize : page * pageSize">
							<td *ngIf="variable.id">
								<a [routerLink]="['.', { outlets: { popup: 'variable-details-popup' }}]"
								   [queryParams]="{ variableId: variable.id }"
								   queryParamsHandling="merge">
								{{variable.alias || variable.name}}
								</a>
							</td>
							<td *ngIf="!variable.id">
								{{variable.name}}
							</td>
							<td>
								{{variable.description}}
							</td>
							<td *ngIf="variable.id && variable.isAlreadyExisting">
								<span class="fa fa-lg fa-check-circle text-success"></span>
							</td>
							<td *ngIf="variable.id && !variable.isAlreadyExisting">
								<span class="fa fa-lg fa-plus-circle text-info"></span>
							</td>
							<td *ngIf="!variable.id">
								<span class="fa fa-lg fa-times-circle text-danger"></span>
							</td>
						</tr>
						</tbody>
					</table>
					<ng-template #nodata>
						<tbody>
						<tr>
							<td colspan="6" jhiTranslate="no.data"></td>
						</tr>
						</tbody>
					</ng-template>
				</div>
				<div>
					<span class="fa fa-check-circle text-success"></span> {{ 'germplasm-list.variable.matches.exist.in.list' | translate }}
					<span class="fa fa-plus-circle text-info"></span> {{ 'germplasm-list.variable.matches.new.to.list' | translate }}
					<span class="fa fa-times-circle text-danger"></span> {{ 'germplasm-list.variable.matches.not.found' | translate }}
				</div>
				<div class="row">
					<div class="col">
						<div class="pagination-container">
							<div class="pagination-box pagination-box-left">
								<div>
									<jhi-item-count [page]="page" [total]="rows.length" [itemsPerPage]="pageSize"></jhi-item-count>
								</div>
							</div>
							<div class="pagination-box">
								<ngb-pagination [collectionSize]="rows.length" [(page)]="page" [pageSize]="pageSize" [disabled]="isLoading"
												[maxSize]="5" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
							</div>
							<div class="pagination-box pagination-box-right">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="back()">
		<span jhiTranslate="back"></span>
	</button>
	<button (click)="next()" class="btn btn-primary" [disabled]="isLoading">
		<span *ngIf="isLoading" class="throbber throbber-btn"></span>
		<span jhiTranslate="next"></span>
	</button>
</div>

